/**
 * Multilingual v3: the reader reads a two-letter first segment as a language (/en/…, resolve.ts), so a top-level folder
 * or project with such a name can be covered by a language version (founder 19.10.2026: warn, do not forbid).
 */
// eslint-disable-next-line import/prefer-default-export
export function isLanguageSlug(slug) {
  return /^[a-z]{2}$/.test(String(slug || ''));
}
